// "Forgot password?" on the retailer login screen.
//
// POST /api/retailer/forgot-password { email } always answers { ok: true },
// whatever the address — so the confirmation below is worded to be true
// either way and never says whether an account exists. The emailed link
// opens /reset-password.html (apps/retailer/public), which sets the new
// password (at least 12 characters) and signs the person out everywhere.

import { api, ApiError } from "@tkos/api-client";
import "./forgot-password.css";

export function renderForgotPassword(rootEl: HTMLElement, onBack: () => void, prefillEmail = ""): void {
  rootEl.replaceChildren();
  const wrap = document.createElement("div");
  wrap.className = "tkos-login";
  wrap.innerHTML = `
    <form class="tkos-login__card" novalidate>
      <div class="tkos-login__brand">Kitchengine</div>
      <div class="tkos-login__sub">Retailer Portal</div>
      <div class="tkos-login__divider"></div>
      <div data-role="ask">
        <p class="tkos-login__lede">Enter the email you sign in with and we’ll send you a link to set a new password.</p>
        <input class="tkos-login__input" type="email" name="email" placeholder="Email" autocomplete="username" required />
        <button class="tkos-login__btn tkos-forgot__send" type="submit">Send reset link</button>
        <div class="tkos-login__error" data-role="error" role="alert" aria-live="polite"></div>
      </div>
      <div data-role="sent" hidden>
        <p class="tkos-login__lede tkos-forgot__sent">If an account uses that email, we’ve sent it a link to set a new password. The link works once and expires in 1 hour. Check your spam folder if it hasn’t arrived in a few minutes.</p>
      </div>
      <button class="tkos-login__link" type="button" data-role="back">Back to sign in</button>
    </form>
  `;
  rootEl.appendChild(wrap);

  const form = wrap.querySelector("form")!;
  const ask = wrap.querySelector<HTMLDivElement>('[data-role="ask"]')!;
  const sent = wrap.querySelector<HTMLDivElement>('[data-role="sent"]')!;
  const emailEl = wrap.querySelector<HTMLInputElement>("input[name='email']")!;
  const btn = wrap.querySelector<HTMLButtonElement>("button[type='submit']")!;
  const errEl = wrap.querySelector<HTMLDivElement>('[data-role="error"]')!;
  wrap.querySelector<HTMLButtonElement>('[data-role="back"]')!.addEventListener("click", onBack);

  emailEl.value = prefillEmail;
  window.setTimeout(() => emailEl.focus(), 50);

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const email = emailEl.value.trim();
    errEl.textContent = "";
    if (!email || !email.includes("@")) { errEl.textContent = "Enter your email address."; return; }
    btn.disabled = true;
    btn.textContent = "Sending…";
    void api<{ ok: boolean }>("/retailer/forgot-password", { method: "POST", body: JSON.stringify({ email }) })
      .then(() => {
        ask.hidden = true;
        sent.hidden = false;
      })
      .catch((err: unknown) => {
        btn.disabled = false;
        btn.textContent = "Send reset link";
        errEl.textContent = err instanceof ApiError && err.status === 429
          ? "Too many requests. Please wait a while and try again."
          : "Connection error. Please try again.";
      });
  });
}
